var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKeyActions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4219 1.07812C10.4219 0.480664 10.9025 0 11.5 0C17.852 0 23 5.14805 23 11.5C23 17.852 17.852 23 11.5 23C5.14805 23 0 17.852 0 11.5C0 9.79746 0.368359 8.18476 1.0332 6.73379C1.30273 6.14082 1.62168 5.5748 1.98555 5.04473L1.99004 5.03574C2.39883 4.43379 2.85703 3.87676 3.36914 3.36914C3.79141 2.94688 4.47422 2.94688 4.89199 3.36914C5.30977 3.79141 5.31426 4.47422 4.89199 4.89199C4.47871 5.30527 4.10137 5.75898 3.76895 6.24414L3.76445 6.25312C2.81211 7.65469 2.22812 9.33027 2.16074 11.1361C2.15625 11.2574 2.15176 11.3787 2.15176 11.5C2.15176 16.6615 6.33398 20.8438 11.4955 20.8438C16.657 20.8438 20.8393 16.6615 20.8393 11.5C20.8393 6.70234 17.2275 2.75371 12.5736 2.21914V4.67188C12.5736 5.26934 12.093 5.75 11.4955 5.75C10.898 5.75 10.4174 5.26934 10.4174 4.67188V1.07812H10.4219Z",
    fill: "#0D2EA0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyActions);
export default __webpack_public_path__ + "static/media/keyActions.6b02d353443f6e6d6c8ec3f24de92bdf.svg";
export { ForwardRef as ReactComponent };